import { action, flow, makeObservable, observable } from "mobx";

import { apiFetcher } from "../utils/fetch";

export default class Announcement {
  constructor() {
    this.items = {};

    makeObservable(this, {
      items: observable,
      setItems: action,
      fetchActive: flow,
    });
  }

  setItems = (type, items) => {
    this.items = { ...this.items, [type]: items };
  };

  *fetchActive(type) {
    try {
      const params = new URLSearchParams();
      if (type) {
        params.append("type", type);
      }
      const queryString = params.toString();
      const response = yield apiFetcher().get(
        `/announcements${queryString ? `?${queryString}` : ""}`
      );
      const announcements = Array.isArray(response.data)
        ? response.data
        : response.data?.data || [];
      this.setItems(type, announcements);

      return { status: response.status, data: announcements };
    } catch (error) {
      return {
        status: error?.response?.status,
        data: error?.response?.data,
      };
    }
  }
}
